import { render, staticRenderFns } from "./EmptyTemplate.vue?vue&type=template&id=ebebea12"
import script from "./EmptyTemplate.vue?vue&type=script&lang=js"
export * from "./EmptyTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports